import i18n from "i18n";
import { S3_TYPE } from "archive/ArchiveStore";
export const OVH_TYPE = "ovh";
export const SYSELEVEN_TYPE = "syseleven";
export const S3_COMPATIBLE_OPTIONS = [
  { value: OVH_TYPE, label: "OVH Object Storage" },
  { value: SYSELEVEN_TYPE, label: "SysEleven Object Storage" }
];
const translate = (key) => i18n.t(key, { ns: "enterprise_data_tiering" });
export const getExternalIdHelp = () => translate("s3_provider_copy.external_id_help");
const neutralAuthCopy = () => ({
  authTypeLabel: translate("s3_provider_copy.neutral.auth_type_label"),
  accessKeyLabel: translate("s3_provider_copy.neutral.access_key_label"),
  accessKeyHelp: translate("s3_provider_copy.neutral.access_key_help"),
  secretKeyLabel: translate("s3_provider_copy.neutral.secret_key_label"),
  secretKeyResetLabel: translate("s3_provider_copy.neutral.secret_key_reset_label"),
  secretKeyHelp: translate("s3_provider_copy.neutral.secret_key_help"),
  regionLabel: translate("s3_provider_copy.neutral.region_label"),
  regionAriaLabel: translate("s3_provider_copy.neutral.region_aria_label"),
  regionHelp: translate("s3_provider_copy.neutral.region_help"),
  regionRequiredError: translate("s3_provider_copy.neutral.region_required_error")
});
const S3_PROVIDER_COPY_BUILDERS = {
  s3: () => ({
    endpointLabel: translate("s3_provider_copy.s3.endpoint_label"),
    endpointHelp: translate("s3_provider_copy.s3.endpoint_help"),
    bucketLabel: translate("s3_provider_copy.s3.bucket_label"),
    bucketHelp: translate("s3_provider_copy.s3.bucket_help"),
    authTypeLabel: translate("s3_provider_copy.s3.auth_type_label"),
    accessKeyLabel: translate("s3_provider_copy.s3.access_key_label"),
    accessKeyHelp: translate("s3_provider_copy.s3.access_key_help"),
    secretKeyLabel: translate("s3_provider_copy.s3.secret_key_label"),
    secretKeyResetLabel: translate("s3_provider_copy.s3.secret_key_reset_label"),
    secretKeyHelp: translate("s3_provider_copy.s3.secret_key_help"),
    regionLabel: translate("s3_provider_copy.s3.region_label"),
    regionAriaLabel: translate("s3_provider_copy.s3.region_aria_label"),
    regionHelp: translate("s3_provider_copy.s3.region_help"),
    regionRequiredError: translate("s3_provider_copy.s3.region_required_error")
  }),
  ovh: () => ({
    endpointLabel: translate("s3_provider_copy.ovh.endpoint_label"),
    endpointHelp: translate("s3_provider_copy.ovh.endpoint_help"),
    bucketLabel: translate("s3_provider_copy.ovh.bucket_label"),
    bucketHelp: translate("s3_provider_copy.ovh.bucket_help"),
    ...neutralAuthCopy()
  }),
  syseleven: () => ({
    endpointLabel: translate("s3_provider_copy.syseleven.endpoint_label"),
    endpointHelp: translate("s3_provider_copy.syseleven.endpoint_help"),
    bucketLabel: translate("s3_provider_copy.syseleven.bucket_label"),
    bucketHelp: translate("s3_provider_copy.syseleven.bucket_help"),
    ...neutralAuthCopy()
  })
};
export const getS3ProviderCopy = (variant) => S3_PROVIDER_COPY_BUILDERS[variant]();
export const getS3Variant = (type) => {
  switch (type) {
    case OVH_TYPE:
      return "ovh";
    case SYSELEVEN_TYPE:
      return "syseleven";
    default:
      return "s3";
  }
};
export const isS3CompatibleType = (type) => type === S3_TYPE || type === OVH_TYPE || type === SYSELEVEN_TYPE;
export const resolveS3CompatibleType = (type) => type === OVH_TYPE || type === SYSELEVEN_TYPE ? S3_TYPE : type;
